import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import request from 'src/utils/request'

const initialState = {
  isLoading: false,
  isSuccess: false,
  specialityData: [],
  semesterData: [],
  specialityNextData: [],
  error: '',
}

export const getSpecialityNext = createAsyncThunk(
  'speciality/getSpecialityNext',
  async ({ ID_SPE }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.student.token
      const res = await request(token).get(`/students/speciality-next`, {
        params: { ID_SPE },
      })
      const data = await res.data

      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const specialitySlice = createSlice({
  name: 'speciality',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSpecialityNext.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(getSpecialityNext.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          specialityNextData: action.payload,
          error: '',
        }
      })
      .addCase(getSpecialityNext.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
  },
})

export default specialitySlice.reducer
